<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {}
	}
</script>

<style>
	#app {
		margin: 0px 0px;
		padding: 0px 0px;
	}

	body {
		margin: 0px 0px;
		padding: 0px 0px;
		background-color: #f8f8f8;
	}
</style>
